import React from "react";
import { useState, useEffect } from "react";
import SideBar from "../../SideBar";
import axios from "axios";
import Switch from "@mui/material/Switch";

import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { FaRegEdit, FaRegTrashAlt, FaArrowLeft } from "react-icons/fa";
import HorizontalScroll from "react-horizontal-scrolling";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
import RedStar from "../../../common/RedStar";
function Unit() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };

  const [medicineLists, setMedicineLists] = useState("");
  const [unitLists, setUnitLists] = useState([]);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [currentQuantity, setCurrentQuantity] = useState("");
  const [reorder, setReorder] = useState("");
  const [fromUnit, setFromUnit] = useState("");
  const [toUnit, setToUnit] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [totalUnit, setTotalUnit] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [Id, setId] = useState("");

  const [description, setDescription] = useState("");
  const [upCode, setUpCode] = useState("");
  const [upName, setUpName] = useState("");
  const [upDesc, setUpDesc] = useState("");
  const [upCurQTY, setUpCurQTY] = useState("");
  const [upReOrder, setUpReOrder] = useState("");
  const [upFrom, setUpFrom] = useState("");
  const [upTo, setUpTo] = useState("");
  const [upTotal, setUpTotal] = useState("");
  const [upPur, setUpPur] = useState("");
  const [upSell, setUpSell] = useState("");
  const [type, setType] = useState("");
  const [setAsReward, setSetAsReward] = useState(false);
  const [upSetAsReward, setUpSetAsReward] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [createErrors, setCreateErrors] = useState({
    code: "",
    name: "",
    currentQuantity: "",
    totalUnit: "",
    purchasePrice: "",
    sellingPrice: "",
    type: "",
  });

  const [updateErrors, setUpdateErrors] = useState({
    upCode: "",
    upName: "",
    upCurQTY: "",
    upTotal: "",
    upPur: "",
    upSell: "",
    type: "",
  });

  // const [medicineListName, setMedicineListname] = useState('');
  const medicineListId = useLocation().pathname.split("/")[2];

  const handleDelete = (event) => {
    console.log(event, "delete");
    api
      .delete("medicine-item/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = unitLists.filter((item) => item._id !== event);
        setUnitLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const submit = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelete(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  const handleUpdate = (event) => {
    console.log(event, "event");
    const getMedUnitUpdate = async () => {
      try {
        const res = await api.get("medicine-item/" + event);

        console.log(res.data.data[0]);
        setUpCode(res.data.data[0].code);
        console.log(res.data.data[0].code, "code");

        setUpName(res.data.data[0].medicineItemName);
        setUpCurQTY(res.data.data[0].currentQuantity);
        setUpReOrder(res.data.data[0].reOrderQuantity);
        setUpFrom(res.data.data[0].fromUnit);
        setUpTo(res.data.data[0].toUnit);
        setUpTotal(res.data.data[0].totalUnit);
        setUpPur(res.data.data[0].purchasePrice);
        setUpSell(res.data.data[0].sellingPrice);
        setUpDesc(res.data.data[0].description);
        setType(res.data.data[0].itemType);
        setUpSetAsReward(res.data.data[0].isReward || false);
      } catch (err) {}
    };
    getMedUnitUpdate();
    setShowUpdate(true);
    setId(event);
  };

  const UnitUpdate = async (e) => {
    e.preventDefault();

    const required = {};

    if (!upCode) {
      required.upCode = "This field is required";
    }
    if (!upName) {
      required.upName = "This field is required";
    }
    if (!upCurQTY) {
      required.upCurQTY = "This field is required";
    }
    if (!upTotal && upTotal !== 0) {
      required.upTotal = "This field is required";
    }
    if (!upPur) {
      required.upPur = "This field is required";
    }
    if (!upSell) {
      required.upSell = "This field is required";
    }

    if (!type) {
      required.type = "This field is required";
    }
    console.log(required);
    if (Object.keys(required).length > 0) {
      setUpdateErrors(required);
      return;
    }

    setUpdateErrors({
      upCode: "",
      upName: "",
      upCurQTY: "",
      upTotal: "",
      upPur: "",
      upSell: "",
      type: "",
    });

    const data = {
      id: Id,
      name: medicineListId,
      code: upCode,
      medicineItemName: upName,
      currentQuantity: upCurQTY,
      reOrderQuantity: upReOrder,
      purchasePrice: upPur,
      sellingPrice: upSell,
      fromUnit: upFrom,
      toUnit: upTo,
      totalUnit: upTotal,
      itemType: type,
      description: upDesc,
      isReward: Boolean(upSetAsReward),
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    await api.put("medicine-item", data, config).then(function (response) {
      setUnitLists((prev) =>
        prev.map((el) =>
          el._id === response.data.data._id ? response.data.data : el,
        ),
      );
      Swal.fire({
        title: "Successful!",
        text: "Medicine Item Updated Successfully!",
        icon: "success",
        cancelButtonText: "Close",
      });
    });
  };

  const handleUpdateUnitCalculation = (event) => {
    console.log(upCurQTY);
    console.log(event);

    if (upCurQTY) {
      let multi = upCurQTY * event;
      let ans = multi / upFrom;

      setUpTotal(ans.toFixed(2));
    }

    setUpTo(event);
  };

  const handleUnitCalculation = (event) => {
    console.log(currentQuantity);
    console.log(event);

    if (currentQuantity) {
      let multi = currentQuantity * event;
      let ans = multi / fromUnit;

      setTotalUnit(ans.toFixed(2));
    }

    setToUnit(event);
  };

  const UnitCreate = async (e) => {
    e.preventDefault();
    const reqired = {};

    if (!code) {
      reqired.code = "Code is required";
    }
    if (!name) {
      reqired.name = "Name is required";
    }
    if (!currentQuantity) {
      reqired.currentQuantity = "Current Quantity is required";
    }
    if (!totalUnit) {
      reqired.totalUnit = "Total Unit is required";
    }
    if (!purchasePrice) {
      reqired.purchasePrice = "Purchase Price is required";
    }
    if (!sellingPrice) {
      reqired.sellingPrice = "Selling Price is required";
    }
    if (!type) {
      reqired.type = "Type is required";
    }

    if (Object.keys(reqired).length > 0) {
      setCreateErrors(reqired);
      return;
    }

    setCreateErrors({
      code: "",
      name: "",
      currentQuantity: "",
      totalUnit: "",
      purchasePrice: "",
      sellingPrice: "",
    });

    const data = {
      id: Id,
      name: medicineListId,
      code: code,
      medicineItemName: name,
      currentQuantity: currentQuantity,
      reOrderQuantity: reorder,
      purchasePrice: purchasePrice,
      sellingPrice: sellingPrice,
      fromUnit: fromUnit,
      toUnit: toUnit,
      totalUnit: totalUnit,
      itemType: type,
      description: description,
      isReward: Boolean(setAsReward),
    };

    // // console.log(medicineListId);
    // alert(JSON.stringify(data))
    console.log(data);
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    await api
      .post("medicine-item", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Medicine Item Created Successfully!",
          icon: "success",

          cancelButtonText: "Close",
        });

        setUnitLists([...unitLists, response.data.data]);
        setCode("");
        setName("");
        setCurrentQuantity("");
        setReorder("");
        setPurchasePrice("");
        setSellingPrice("");
        setFromUnit("");
        setToUnit("");
        setTotalUnit("");
        setType("");
        setDescription("");
        setSetAsReward(false);
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    document.getElementById("description").value = "";
    document.getElementById("name").value = "";
    document.getElementById("code").value = "";
    document.getElementById("cur_qty").value = "";
    document.getElementById("reorder").value = "";
    document.getElementById("purchase").value = "";
    document.getElementById("from").value = "";
    document.getElementById("to").value = "";
    document.getElementById("sellprice").value = "";
    document.getElementById("total").value = "";

    //      props.setOpen(false);
  };
  const handleTotalUnit = () => {
    setTotalUnit(currentQuantity * (toUnit / fromUnit) || 0);
  };

  const handleUpdateTotalUnit = () => {
    setUpTotal(upCurQTY * (upTo / upFrom) || 0);
  };

  useEffect(() => {
    handleUpdateTotalUnit();
  }, [upCurQTY, upTo, upFrom]);

  useEffect(() => {
    handleTotalUnit();
  }, [fromUnit, toUnit, currentQuantity]);

  useEffect(() => {
    const getUnitLists = async () => {
      setIsLoading(true);
      try {
        const res = await api.get("medicine-items/" + medicineListId);

        // setUnitLists(res.data.list.filter((el)=>el.name._id == medicineListId))
        setUnitLists(res.data.data);
        // console.log(res.data.data, 'list')
      } catch (err) {
      } finally {
        setIsLoading(false);
      }
    };

    const getMedicineLists = async () => {
      try {
        const res = await api.get("medicine-list/" + medicineListId);
        let setMedicineListname = res.data.data[0].name;
        setMedicineLists(setMedicineListname);
      } catch (err) {
        alert(err.message);
      }
    };

    getMedicineLists();
    getUnitLists();
  }, []);
  return (
    <div classNameName="App">
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/medicine_list">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item active"
                      style={{ marginTop: "0.2em" }}
                    >
                      <i>Medicine Item Unit List</i>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div className="row">
                <div className="col-9">
                  <div className="card">
                    <div className="card-header">{medicineLists}</div>
                    <div className="card-body bg-light" style={scroll}>
                      <table id="" className="table">
                        <thead className="text-center bg-info sticky-top ">
                          <tr>
                            <th>No</th>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Current Qty</th>
                            <th>Reorder Qty</th>
                            <th>Purchase Price</th>
                            <th>Selling Price</th>
                            <th>Unit Convention</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody className="">
                          {isLoading ? (
                            <tr className="text-center">
                              <td colSpan="11">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            unitLists.map((unit, i) => (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{unit.code}</td>
                                <td>{unit.medicineItemName}</td>
                                <td>
                                  {unit.currentQuantity
                                    ? unit.currentQuantity
                                    : "0"}
                                </td>
                                <td>{unit.reOrderQuantity}</td>
                                <td>{unit.purchasePrice}</td>
                                <td>{unit.sellingPrice}</td>

                                <td>{unit.toUnit ? unit.toUnit : "0"}</td>
                                <td>{unit.itemType ? unit.itemType : ""}</td>
                                <td>{unit.description}</td>
                                <td className="text-center">
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={(e) => handleUpdate(unit._id)}
                                  >
                                    <FaRegEdit />
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={(e) => submit(unit._id)}
                                  >
                                    <FaRegTrashAlt />
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {showUpdate ? (
                  <div className="col-md-3">
                    <form onSubmit={(e) => UnitUpdate(e)}>
                      <div className="card px-3 py-3">
                        <h3 className="card-header mb-4 fw-5 text-secondary">
                          Update Item
                        </h3>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Code
                          </label>
                          <input
                            type="text"
                            class="form-control border-info"
                            name="codename"
                            id="code"
                            value={upCode}
                            onChange={(e) => setUpCode(e.target.value)}
                          />
                          {updateErrors.upCode && (
                            <div className="text-danger">
                              {updateErrors.upCode}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control border-info"
                            name="balance"
                            id="name"
                            value={upName}
                            onChange={(e) => setUpName(e.target.value)}
                          />
                          {updateErrors.upName && (
                            <div className="text-danger">
                              {updateErrors.upName}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Current Quantity
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="cur_qty"
                            value={upCurQTY}
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            onChange={(e) => {
                              setUpCurQTY(e.target.value);
                            }}
                          />
                          {updateErrors.upCurQTY && (
                            <div className="text-danger">
                              {updateErrors.upCurQTY}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Reorder Quantity (Optional)
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="reorder"
                            value={upReOrder}
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            onChange={(e) => setUpReOrder(e.target.value)}
                          />
                          {updateErrors.upReOrder && (
                            <div className="text-danger">
                              {updateErrors.upReOrder}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Unit Convention (Optional)
                          </label>
                          <div className="row">
                            <div className="col-md-6">
                              <input
                                type="number"
                                class="form-control border-info"
                                name="balance"
                                id="from"
                                value={upFrom}
                                onWheel={(e) => e.target.blur()}
                                min="0"
                                onChange={(e) => {
                                  setUpFrom(e.target.value);
                                }}
                              />
                              <div className="text-danger">
                                {updateErrors.upFrom && (
                                  <div className="text-danger">
                                    {updateErrors.upFrom}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="number"
                                class="form-control border-info"
                                name="balance"
                                id="to"
                                value={upTo}
                                onWheel={(e) => e.target.blur()}
                                min="0"
                                onChange={(e) => {
                                  handleUpdateUnitCalculation(e.target.value);
                                }}
                              />
                              <div className="text-danger">
                                {updateErrors.upTo && (
                                  <div className="text-danger">
                                    {updateErrors.upTo}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Total Unit
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="total"
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            value={upTotal}
                          />
                          {updateErrors.upTotal && (
                            <div className="text-danger">
                              {updateErrors.upTotal}
                            </div>
                          )}
                        </div>

                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Purchase Price
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="purchase"
                            value={upPur}
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            onChange={(e) => setUpPur(e.target.value)}
                          />
                          {updateErrors.upPur && (
                            <div className="text-danger">
                              {updateErrors.upPur}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Selling Price
                          </label>
                          <div className="row">
                            <div className="col-md-12">
                              <input
                                type="number"
                                class="form-control border-info"
                                name="balance"
                                id="sellprice"
                                value={upSell}
                                onWheel={(e) => e.target.blur()}
                                min="0"
                                onChange={(e) => setUpSell(e.target.value)}
                              />
                            </div>
                            {updateErrors.upSell && (
                              <div className="text-danger">
                                {updateErrors.upSell}
                              </div>
                            )}
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Type
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) => setType(e.target.value)}
                          >
                            <option value={type} hidden>
                              {type}
                            </option>
                            <option value="Oral">Oral</option>
                            <option value="Topical">Topical</option>
                            <option value="Cosmetic">Cosmetic</option>
                            <option value="Consignment">Consignment</option>
                            <option value="Accessories">Accessories</option>
                          </select>
                          {updateErrors.type && (
                            <div className="text-danger">
                              {updateErrors.type}
                            </div>
                          )}
                        </div>

<div class="form-group">
                  <label for="name" className="text-secondary">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    id="description"
                    value={upDesc}
                    onChange={(e) => setUpDesc(e.target.value)}
                  ></textarea>
                </div>
                <div class="form-group d-flex align-items-center">
                  <label className="mb-0 mr-3">Set as Reward</label>
                  <Switch
                    checked={upSetAsReward}
                    onChange={(e) => setUpSetAsReward(e.target.checked)}
                  />
                </div>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-secondary form-control text-center fw-5"
                            onClick={() => setShowUpdate(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary form-control text-center fw-5"
                            type="submit"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                ) : (
                  <div className="col-md-3">
                    <form onSubmit={(e) => UnitCreate(e)}>
                      <div className="card px-3 py-3">
                        <h3 className="card-header mb-4 fw-5 text-secondary">
                          Create Item
                        </h3>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Code <RedStar />
                          </label>
                          <input
                            type="text"
                            class="form-control border-info"
                            name="codename"
                            id="code"
                            value={code}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setCode(e.target.value)}
                          />
                          {createErrors?.code && (
                            <div className="text-danger">
                              {createErrors?.code}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Name <RedStar />
                          </label>
                          <input
                            type="text"
                            class="form-control border-info"
                            name="balance"
                            id="name"
                            value={name}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setName(e.target.value)}
                          />
                          {createErrors?.name && (
                            <div className="text-danger">
                              {createErrors?.name}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Current Quantity <RedStar />
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="cur_qty"
                            min={0}
                            value={currentQuantity}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => setCurrentQuantity(e.target.value)}
                          />
                          {createErrors?.currentQuantity && (
                            <div className="text-danger">
                              {createErrors?.currentQuantity}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Reorder Quantity (Optional)
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="reorder"
                            min={0}
                            value={reorder}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => setReorder(e.target.value)}
                          />
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Unit Convention (Optional)
                          </label>
                          <div className="row">
                            <div className="col-md-6">
                              <input
                                type="number"
                                class="form-control border-info"
                                name="balance"
                                id="from"
                                min={0}
                                value={fromUnit}
                                placeholder="Form Unit"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) => setFromUnit(e.target.value)}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="number"
                                class="form-control border-info"
                                name="balance"
                                id="to"
                                min={0}
                                value={toUnit}
                                placeholder="To Unit"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) =>
                                  handleUnitCalculation(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Total Unit <RedStar />
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="total"
                            min={0}
                            value={totalUnit}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => setTotalUnit(e.target.value)}
                          />
                          {createErrors?.totalUnit && (
                            <div className="text-danger">
                              {createErrors?.totalUnit}
                            </div>
                          )}
                        </div>

                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Purchase Price <RedStar />
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="purchase"
                            min={0}
                            value={purchasePrice}
                            onWheel={(e) => e.target.blur()}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setPurchasePrice(e.target.value)}
                          />
                          {createErrors?.purchasePrice && (
                            <div className="text-danger">
                              {createErrors?.purchasePrice}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Selling Price <RedStar />
                          </label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="balance"
                            id="sellprice"
                            min={0}
                            value={sellingPrice}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => setSellingPrice(e.target.value)}
                          />
                          {createErrors?.sellingPrice && (
                            <div className="text-danger">
                              {createErrors?.sellingPrice}
                            </div>
                          )}
                        </div>
                        <div class="form-group">
                          <label for="name" className="text-secondary">
                            Type <RedStar />
                          </label>
                          <select
                            className="form-control"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                          >
                            <option value="" hidden>
                              Select Type
                            </option>
                            <option value="Oral">Oral</option>
                            <option value="Topical">Topical</option>
                            <option value="Cosmetic">Cosmetic</option>
                            <option value="Consignment">Consignment</option>
                            <option value="Accessories">Accessories</option>
                          </select>
                          {createErrors?.type && (
                            <div className="text-danger">
                              {createErrors?.type}
                            </div>
                          )}
                        </div>

<div class="form-group">
                  <label for="name" className="text-secondary">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    id="description"
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>
                <div class="form-group d-flex align-items-center">
                  <label className="mb-0 mr-3">Set as Reward</label>
                  <Switch
                    checked={setAsReward}
                    onChange={(e) => setSetAsReward(e.target.checked)}
                  />
                </div>
                        <button
                          className="btn btn-primary form-control text-center fw-5"
                          type={"submit"}
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}

      {/* <!-- Control Sidebar --> */}
      <aside classNameName="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default Unit;
